var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-list",
    [
      _c(
        "v-list-group",
        {
          attrs: { "no-action": "", "prepend-icon": "fas fa-tools" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function() {
                return [
                  _c("v-list-item-title", [
                    _vm._v(_vm._s(_vm.$t("global.menu.configurations")))
                  ])
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _vm.$checkFunctionality("COUNTRIES")
            ? _c(
                "v-list-item",
                { attrs: { link: "", to: { name: "countries" } } },
                [
                  _c(
                    "v-list-item-icon",
                    [_c("v-icon", [_vm._v("fas fa-globe-europe")])],
                    1
                  ),
                  _c(
                    "v-list-item-content",
                    [
                      _c("v-list-item-title", [
                        _vm._v(_vm._s(_vm.$t("global.menu.countries")))
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.$checkFunctionality("AGENCIES")
            ? _c(
                "v-list-item",
                { attrs: { link: "", to: { name: "agencies" } } },
                [
                  _c(
                    "v-list-item-icon",
                    [_c("v-icon", [_vm._v("fas fa-warehouse")])],
                    1
                  ),
                  _c(
                    "v-list-item-content",
                    [
                      _c("v-list-item-title", [
                        _vm._v(_vm._s(_vm.$t("global.menu.agencies")))
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.$checkFunctionality("PROFILES")
            ? _c(
                "v-list-item",
                { attrs: { link: "", to: { name: "profiles" } } },
                [
                  _c(
                    "v-list-item-icon",
                    [_c("v-icon", [_vm._v("fas fa-id-card")])],
                    1
                  ),
                  _c(
                    "v-list-item-content",
                    [
                      _c("v-list-item-title", [
                        _vm._v(_vm._s(_vm.$t("global.menu.profiles")))
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.$checkFunctionality("USERS")
            ? _c(
                "v-list-item",
                { attrs: { link: "", to: { name: "users" } } },
                [
                  _c(
                    "v-list-item-icon",
                    [_c("v-icon", [_vm._v("fas fa-user-alt")])],
                    1
                  ),
                  _c(
                    "v-list-item-content",
                    [
                      _c("v-list-item-title", [
                        _vm._v(_vm._s(_vm.$t("global.menu.users")))
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.$checkFunctionality("ROUTES")
            ? _c(
                "v-list-item",
                { attrs: { link: "", to: { name: "routes" } } },
                [
                  _c(
                    "v-list-item-icon",
                    [_c("v-icon", [_vm._v("fas fa-route")])],
                    1
                  ),
                  _c(
                    "v-list-item-content",
                    [
                      _c("v-list-item-title", [
                        _vm._v(_vm._s(_vm.$t("global.menu.routes")))
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.$checkFunctionality("ZONES")
            ? _c(
                "v-list-item",
                { attrs: { link: "", to: { name: "zones" } } },
                [
                  _c(
                    "v-list-item-icon",
                    [_c("v-icon", [_vm._v("fas fa-layer-group")])],
                    1
                  ),
                  _c(
                    "v-list-item-content",
                    [
                      _c("v-list-item-title", [
                        _vm._v(_vm._s(_vm.$t("global.menu.zones")))
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.$checkFunctionality("POSTALCODES")
            ? _c(
                "v-list-item",
                { attrs: { link: "", to: { name: "postalCodes" } } },
                [
                  _c(
                    "v-list-item-icon",
                    [_c("v-icon", [_vm._v("fas fa-mail-bulk")])],
                    1
                  ),
                  _c(
                    "v-list-item-content",
                    [
                      _c("v-list-item-title", [
                        _vm._v(_vm._s(_vm.$t("global.menu.postalCodes")))
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.$checkFunctionality("HOLIDAYS")
            ? _c(
                "v-list-item",
                { attrs: { link: "", to: { name: "holidays" } } },
                [
                  _c(
                    "v-list-item-icon",
                    [_c("v-icon", [_vm._v("fas fa-calendar-times")])],
                    1
                  ),
                  _c(
                    "v-list-item-content",
                    [
                      _c("v-list-item-title", [
                        _vm._v(_vm._s(_vm.$t("global.menu.holidays")))
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.$checkFunctionality("SERVICES")
            ? _c(
                "v-list-item",
                { attrs: { link: "", to: { name: "services" } } },
                [
                  _c(
                    "v-list-item-icon",
                    [_c("v-icon", [_vm._v("fas fa-truck-loading")])],
                    1
                  ),
                  _c(
                    "v-list-item-content",
                    [
                      _c("v-list-item-title", [
                        _vm._v(_vm._s(_vm.$t("global.menu.services")))
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.$checkFunctionality("AGENCYPARAMETERS")
            ? _c(
                "v-list-item",
                { attrs: { link: "", to: { name: "agencyParameters" } } },
                [
                  _c(
                    "v-list-item-icon",
                    [_c("v-icon", [_vm._v("fas fa-boxes")])],
                    1
                  ),
                  _c(
                    "v-list-item-content",
                    [
                      _c("v-list-item-title", [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("global.menu.agencyParameters")) +
                            " "
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.$checkFunctionality("CLIENTS")
            ? _c(
                "v-list-item",
                { attrs: { link: "", to: { name: "clients" } } },
                [
                  _c(
                    "v-list-item-icon",
                    [_c("v-icon", [_vm._v("fas fa-users")])],
                    1
                  ),
                  _c(
                    "v-list-item-content",
                    [
                      _c("v-list-item-title", [
                        _vm._v(_vm._s(_vm.$t("global.menu.clients")))
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.$checkFunctionality("TIMESLOTS")
            ? _c(
                "v-list-item",
                { attrs: { link: "", to: { name: "timeSlots" } } },
                [
                  _c(
                    "v-list-item-icon",
                    [_c("v-icon", [_vm._v("fas fa-business-time")])],
                    1
                  ),
                  _c(
                    "v-list-item-content",
                    [
                      _c("v-list-item-title", [
                        _vm._v(_vm._s(_vm.$t("global.menu.timeSlots")))
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.$checkFunctionality("PRODUCTSTYPES")
            ? _c(
                "v-list-item",
                { attrs: { link: "", to: { name: "productsTypes" } } },
                [
                  _c(
                    "v-list-item-icon",
                    [_c("v-icon", [_vm._v("fas fa-boxes")])],
                    1
                  ),
                  _c(
                    "v-list-item-content",
                    [
                      _c("v-list-item-title", [
                        _vm._v(_vm._s(_vm.$t("global.menu.productsTypes")))
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "v-list",
        [
          _vm.$checkFunctionality("TIMESLOTS")
            ? _c(
                "v-list-item",
                { attrs: { link: "", to: { name: "statistics" } } },
                [
                  _c(
                    "v-list-item-icon",
                    [_c("v-icon", [_vm._v("fas fa-chart-area")])],
                    1
                  ),
                  _c(
                    "v-list-item-content",
                    [
                      _c("v-list-item-title", [
                        _vm._v(_vm._s(_vm.$t("global.menu.statistics")))
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "v-list",
        [
          _vm.$checkFunctionality("AUDIT")
            ? _c(
                "v-list-item",
                { attrs: { link: "", to: { name: "audit" } } },
                [
                  _c(
                    "v-list-item-icon",
                    [_c("v-icon", [_vm._v("fas fa-audio-description")])],
                    1
                  ),
                  _c(
                    "v-list-item-content",
                    [
                      _c("v-list-item-title", [
                        _vm._v(_vm._s(_vm.$t("global.menu.audit")))
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "v-list",
        [
          _vm.$checkFunctionality("TIMESLOTSRESERVATIONS")
            ? _c(
                "v-list-item",
                { attrs: { link: "", to: { name: "timeSlotsReservations" } } },
                [
                  _c(
                    "v-list-item-icon",
                    [_c("v-icon", [_vm._v("fas fa-calendar-check")])],
                    1
                  ),
                  _c(
                    "v-list-item-content",
                    [
                      _c("v-list-item-title", [
                        _vm._v(
                          _vm._s(_vm.$t("global.menu.timeSlotsReservations"))
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }